import React from 'react';
import { Accordion, AccordionSummary, Typography, AccordionDetails } from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { jbColors } from 'theme/jbColors';

interface AccordionGridWrapperProps {
  title: string;
  children?: React.ReactNode;
  titleIcon?: React.ReactNode;
  expandedProp?: boolean;
  customCloseAction?: boolean;
  showExpandIcon?: boolean;
  style?: React.CSSProperties;
}

const AccordionGridWrapper = ({
  expandedProp = true,
  customCloseAction,
  showExpandIcon = true,
  titleIcon,
  children,
  title,
  style = { borderRadius: 0 },
}: AccordionGridWrapperProps) => {
  const [expanded, onChange] = React.useState(expandedProp);
  const [prevExpandedProp, setPrevExpandedProp] = React.useState(expandedProp);
  if (expandedProp !== prevExpandedProp) {
    setPrevExpandedProp(expandedProp);
    if (expandedProp !== undefined) {
      onChange(expandedProp);
    }
  }

  const handleChange = () => {
    onChange(expanded ? false : true);
  };

  return (
    <Accordion
      disableGutters
      data-testid={'accordion-grid-wrapper'}
      expanded={expanded}
      onChange={!customCloseAction ? handleChange : () => null}
      style={style}
      sx={{
        display: 'flex',
        flexDirection: 'column',
        borderRadius: 0,
        //cursor: customCloseAction ? 'context-menu !important' : 'pointer',
        marginBottom: 0,
        '&.MuiPaper-root': {
          mb: 1,
          paddingLeft: 1,
          paddingTop: 0,
          paddingBottom: 1,
        },
        '&.MuiButtonBase-root': {
          color: 'red !important',
        },
      }}
    >
      <AccordionSummary
        sx={{
          borderRadius: 0,
          cursor: customCloseAction ? 'context-menu !important' : 'pointer',
          paddingBottom: 0,
          marginLeft: '-1.5em',
          marginBottom: !showExpandIcon ? '-1em' : 0,
        }}
        expandIcon={
          showExpandIcon ? (
            <ExpandMoreIcon
              sx={{
                cursor: 'pointer',
                color: 'gray',
                ':hover': {
                  color: 'white',
                  borderRadius: '50%',
                  backgroundColor: jbColors.core.reflexBlue[100],
                },
              }}
              onClick={customCloseAction ? handleChange : () => null}
            />
          ) : null
        }
        aria-controls="panel1a-content"
        id="panel1a-header"
      >
        {titleIcon}
        <Typography color="primary" variant={'h4'} sx={{ marginBottom: 0, marginLeft: 0.5 }}>
          {title}
        </Typography>
      </AccordionSummary>
      {children && (
        <AccordionDetails sx={{ p: 0, marginLeft: 1, marginRight: 2.2, paddingRight: '0.5em' }}>
          {children}
        </AccordionDetails>
      )}
    </Accordion>
  );
};

export default AccordionGridWrapper;
